import React, { useState } from 'react';
import { ChevronDown, Sparkles, Code } from 'lucide-react';
import FeatureCard from './FeatureCard';

const features = {
  main: [
    'Fully customizable button appearance',
    'Multiple position options',
    'Brand color matching',
    'Custom text and icon options'
  ],
  integration: [
    'Simple copy-paste installation',
    'No dependencies required',
    'Works with any website',
    'Automatic updates'
  ]
};

const FeatureGrid = () => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-4 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-3">
          <Sparkles className="w-5 h-5 text-gray-500" />
          <span className="text-xl font-semibold text-gray-900">
            Features
          </span>
        </div>
        <ChevronDown
          className={`w-5 h-5 text-gray-500 transition-transform ${
            isOpen ? 'transform rotate-180' : ''
          }`}
        />
      </button>

      {isOpen && (
        <div className="px-6 py-4 border-t border-gray-200">
          <div className="grid md:grid-cols-2 gap-6">
            <FeatureCard
              icon={<Sparkles className="w-5 h-5 text-indigo-600" />}
              title="Customization"
              features={features.main}
            />
            <FeatureCard
              icon={<Code className="w-5 h-5 text-indigo-600" />}
              title="Integration"
              features={features.integration}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default FeatureGrid;